import Stripe from 'stripe';

/**
 * When an overdue renewal's discount offers open: the moment the dunning worker's third email
 * makes them (`DUNNING_OFFSETS_HOURS`, "2 72 168 288", so day 7 after the charge failed). Before
 * that the customer is asked to pay or update the card, and offered nothing off.
 *
 * Rob, 2026-09-30, choosing day 7 over "immediately": the Settings row used to offer "Keep it for
 * less" from the first failed charge while the emails held it for day 7. The first two customers to
 * take it did so six minutes and nineteen hours after their card failed, and would have paid anyway.
 *
 * Staging's worker runs compressed offsets (step 3 at 0.15 hours), so there the offer opens after
 * nine minutes and can be tested end to end.
 */
export const getPastDueOfferOpensAfterHours = () =>
  process.env.APP_STAGE === 'production' ? 168 : 0.15;

/**
 * When the offer opens on this invoice, in epoch seconds. A renewal is charged when its invoice is
 * finalized, so that is when it first failed.
 */
export const getPastDueOfferOpensAt = (
  invoice: Pick<Stripe.Invoice, 'created' | 'status_transitions'>,
) =>
  (invoice.status_transitions?.finalized_at ?? invoice.created) +
  Math.round(getPastDueOfferOpensAfterHours() * 60 * 60);

/** Whether the offer is open. An unknown opening time is closed: the server is asked instead. */
export const isPastDueOfferOpen = (opensAt: number | null | undefined, nowMs = Date.now()) =>
  typeof opensAt === 'number' && nowMs >= opensAt * 1000;
